"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/sitesservice/v1/api/site";
var config = {
  siteBulk: serviceURL + "/bulk",
  site: serviceURL,
  siteEditor: serviceURL + "/editor",
  siteEdit: serviceURL + "/edit"
};
exports.config = config;